import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { saveSystemAction } from '../SystemAction';

const FormSystem = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const systemStore = Redux.useSelector((state) => state.system);

  const activo = systemStore.activo;

  const initData = {
    name: '',
    url: '',
    desc: '',
    appVersion: '',
    beforeVersion: '',
    andriodVersion: '',
    iosVersion: '',
    webVersion: '',
    desktopVersion: '',
    urlDownload: null,
    forceUpdate: false,
    maintenance: false,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    name: false,
    url: false,
    desc: false,
    appVersion: false,
    beforeVersion: false,
    andriodVersion: false,
    iosVersion: false,
    webVersion: false,
    desktopVersion: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(() => setData(values), 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveSystemAction(
        { dispatch, notify },
        activo.id,
        data,
        systemStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id="name"
            required
            label={CONST.nombre.label}
            value={data.name}
            onChange={(e) => _handleSetDataField('name', e.target.value)}
            helperText={dataError.name ? validMessage.required : null}
            error={dataError.name}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id="url"
            label="URL de la web"
            value={data.url}
            onChange={(e) => _handleSetDataField('url', e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id="urlDownload"
            required
            label="Link de descarga de la app"
            value={data.urlDownload ?? ''}
            onChange={(e) => _handleSetDataField('urlDownload', e.target.value)}
            helperText={dataError.urlDownload ? validMessage.required : null}
            error={dataError.urlDownload}
          />
        </Grid>

        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.desc.name}
            label={CONST.desc.label}
            value={data.desc}
            multiline
            rows={4}
            onChange={(e) =>
              _handleSetDataField(CONST.desc.name, e.target.value)
            }
            helperText={dataError.desc ? validMessage.required : null}
            error={dataError.desc}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id="appVersion"
            label="Versión actual"
            value={data.appVersion}
            onChange={(e) => _handleSetDataField('appVersion', e.target.value)}
            helperText={dataError.appVersion ? validMessage.required : null}
            error={dataError.appVersion}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size="small"
            id="beforeVersion"
            label="Versión anterior"
            value={data.beforeVersion}
            onChange={(e) =>
              _handleSetDataField('beforeVersion', e.target.value)
            }
            helperText={dataError.beforeVersion ? validMessage.required : null}
            error={dataError.beforeVersion}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.forceUpdate}
                onChange={(e) =>
                  _handleSetDataField('forceUpdate', e.target.checked)
                }
              />
            }
            label="Forzar actualización"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <FormControlLabel
            control={
              <Checkbox
                checked={data.maintenance}
                onChange={(e) =>
                  _handleSetDataField('maintenance', e.target.checked)
                }
              />
            }
            label="Mantenimiento"
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            size="small"
            id="andriodVersion"
            label="Versión en ANDRIOD"
            value={data.andriodVersion}
            onChange={(e) =>
              _handleSetDataField('andriodVersion', e.target.value)
            }
            helperText={dataError.andriodVersion ? validMessage.required : null}
            error={dataError.andriodVersion}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            size="small"
            id="iosVersion"
            label="Versión en IOS"
            value={data.iosVersion}
            onChange={(e) => _handleSetDataField('iosVersion', e.target.value)}
            helperText={dataError.iosVersion ? validMessage.required : null}
            error={dataError.iosVersion}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            size="small"
            id="webVersion"
            label="Versión de la WEB"
            value={data.webVersion}
            onChange={(e) => _handleSetDataField('webVersion', e.target.value)}
            helperText={dataError.webVersion ? validMessage.required : null}
            error={dataError.webVersion}
          />
        </Grid>

        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            size="small"
            id="desktopVersion"
            label="Versión en DESKTOP"
            value={data.desktopVersion}
            onChange={(e) =>
              _handleSetDataField('desktopVersion', e.target.value)
            }
            helperText={dataError.desktopVersion ? validMessage.required : null}
            error={dataError.desktopVersion}
          />
        </Grid>

        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormSystem;
